import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { versionSystem } from "../../../package.json";
import { i18n } from "../../translate/i18n";
import { nomeEmpresa } from "../../../package.json";
import { AuthContext } from "../../context/Auth/AuthContext";
import logo from "../../assets/logo.png";
import { IconButton, Menu, MenuItem, InputAdornment, Paper } from "@material-ui/core";
import LanguageControl from "../../components/LanguageControl";
import { 
	LanguageOutlined, 
	Visibility, 
	VisibilityOff,
	Email,
	Lock,
	ArrowForward
} from "@material-ui/icons";

const Copyright = () => {
	return (
		<Typography variant="body2" style={{ color: "rgba(255,255,255,0.7)" }} align="center">
			{"© "}
			{new Date().getFullYear()}
			{" "}
			<Link style={{ color: "rgba(255,255,255,0.9)" }} href="#">
				{nomeEmpresa}
			</Link>
			{" · v"}{versionSystem}
		</Typography>
	);
};

const useStyles = makeStyles(theme => ({
	root: {
		width: "100vw",
		height: "100vh",
		display: "flex",
		flexDirection: "row",
		overflow: "hidden",
	},
	// Lado esquerdo - Background com gradiente e padrão
	leftSide: {
		flex: 1,
		background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 50%, #A855F7 100%)",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		position: "relative",
		overflow: "hidden",
		padding: theme.spacing(4),
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
		// Padrão de fundo
		"&::before": {
			content: '""',
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
			opacity: 0.5,
		},
		// Círculos decorativos
		"&::after": {
			content: '""',
			position: "absolute",
			width: "400px",
			height: "400px",
			borderRadius: "50%",
			background: "rgba(255,255,255,0.1)",
			top: "-100px",
			right: "-100px",
		}
	},
	leftContent: {
		position: "relative",
		zIndex: 1,
		textAlign: "center",
		color: "#fff",
		maxWidth: 500,
	},
	heroTitle: {
		fontSize: "2.5rem",
		fontWeight: 700,
		marginBottom: theme.spacing(2),
		textShadow: "0 2px 10px rgba(0,0,0,0.2)",
	},
	heroSubtitle: {
		fontSize: "1.1rem",
		opacity: 0.9,
		marginBottom: theme.spacing(4),
		lineHeight: 1.6,
	},
	featureList: {
		textAlign: "left",
		"& > div": {
			display: "flex",
			alignItems: "center",
			marginBottom: theme.spacing(2),
			padding: theme.spacing(1.5, 2),
			background: "rgba(255,255,255,0.1)",
			borderRadius: 12,
			backdropFilter: "blur(10px)",
		},
		"& svg": {
			marginRight: theme.spacing(2),
			fontSize: 24,
		}
	},
	// Lado direito - Formulário
	rightSide: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		padding: theme.spacing(4),
		background: theme.palette.type === "dark" ? "#0F172A" : "#F8FAFC",
		[theme.breakpoints.down("sm")]: {
			flex: "none",
			width: "100%",
			height: "100%",
		},
	},
	formContainer: {
		width: "100%",
		maxWidth: 420,
	},
	logoContainer: {
		textAlign: "center",
		marginBottom: theme.spacing(4),
	},
	logo: {
		maxWidth: 180,
		marginBottom: theme.spacing(2),
	},
	welcomeText: {
		fontSize: "1.75rem",
		fontWeight: 700,
		color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
		marginBottom: theme.spacing(1),
	},
	subtitleText: {
		color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
		marginBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(4),
		borderRadius: 20,
		background: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
		boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
	},
	form: {
		width: "100%",
	},
	textField: {
		marginBottom: theme.spacing(2.5),
		"& .MuiOutlinedInput-root": {
			borderRadius: 12,
			background: theme.palette.type === "dark" ? "#0F172A" : "#F8FAFC",
			transition: "all 0.3s ease",
			"&:hover": {
				background: theme.palette.type === "dark" ? "#1E293B" : "#F1F5F9",
			},
			"&.Mui-focused": {
				background: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
				boxShadow: "0 0 0 3px rgba(99, 102, 241, 0.2)",
			}
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.type === "dark" ? "#334155" : "#E2E8F0",
		},
		"& .MuiInputLabel-root": {
			color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
		},
		"& .MuiInputAdornment-root": {
			color: theme.palette.type === "dark" ? "#64748B" : "#94A3B8",
		}
	},
	submitButton: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(3),
		padding: theme.spacing(1.5),
		borderRadius: 12,
		fontSize: "1rem",
		fontWeight: 600,
		background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
		boxShadow: "0 4px 15px rgba(99, 102, 241, 0.4)",
		transition: "all 0.3s ease",
		"&:hover": {
			transform: "translateY(-2px)",
			boxShadow: "0 6px 20px rgba(99, 102, 241, 0.5)",
		}
	},
	links: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		"& a": {
			color: "#6366F1",
			fontWeight: 500,
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline",
			}
		}
	},
	languageButton: {
		position: "absolute",
		top: theme.spacing(2),
		right: theme.spacing(2),
		color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
	},
	decorCircle1: {
		position: "absolute",
		width: 200,
		height: 200,
		borderRadius: "50%",
		background: "rgba(139, 92, 246, 0.1)",
		bottom: -50,
		left: -50,
	},
	decorCircle2: {
		position: "absolute",
		width: 150,
		height: 150,
		borderRadius: "50%",
		background: "rgba(99, 102, 241, 0.1)",
		top: 50,
		right: -30,
	},
}));

const Login = () => {
	const classes = useStyles();

	const [user, setUser] = useState({ email: "", password: "" });
	const [showPassword, setShowPassword] = useState(false);

	// Languages
	const [anchorElLanguage, setAnchorElLanguage] = useState(null);
	const [menuLanguageOpen, setMenuLanguageOpen] = useState(false);

	const { handleLogin } = useContext(AuthContext);

	const handleChangeInput = e => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};

	const handlSubmit = e => {
		e.preventDefault();
		handleLogin(user);
	};

	const handlemenuLanguage = (event) => {
		setAnchorElLanguage(event.currentTarget);
		setMenuLanguageOpen(true);
	}

	const handleCloseMenuLanguage = () => {
		setAnchorElLanguage(null);
		setMenuLanguageOpen(false);
	}

	return (
		<div className={classes.root}>
			<CssBaseline />
			
			{/* Lado Esquerdo - Hero Section */}
			<div className={classes.leftSide}>
				<div className={classes.leftContent}>
					<Typography className={classes.heroTitle}>
						Bem-vindo ao Omni
					</Typography>
					<Typography className={classes.heroSubtitle}>
						A plataforma completa de atendimento omnichannel que transforma 
						a comunicação da sua empresa com seus clientes.
					</Typography>
					
					<div className={classes.featureList}>
						<div>
							<span role="img" aria-label="whatsapp">💬</span>
							<Typography>WhatsApp Oficial & Web integrados</Typography>
						</div>
						<div>
							<span role="img" aria-label="robot">🤖</span>
							<Typography>Chatbots inteligentes com IA</Typography>
						</div>
						<div>
							<span role="img" aria-label="chart">📊</span>
							<Typography>Dashboard completo e relatórios</Typography>
						</div>
						<div>
							<span role="img" aria-label="team">👥</span>
							<Typography>Gestão de equipes e filas</Typography>
						</div>
					</div>
				</div>
				
				<Box position="absolute" bottom={40}>
					<Copyright />
				</Box>
			</div>

			{/* Lado Direito - Formulário */}
			<div className={classes.rightSide}>
				{/* Círculos decorativos */}
				<div className={classes.decorCircle1} />
				<div className={classes.decorCircle2} />
				
				{/* Botão de idioma */}
				<IconButton 
					className={classes.languageButton}
					onClick={handlemenuLanguage}
				>
					<LanguageOutlined />
				</IconButton>
				<Menu
					anchorEl={anchorElLanguage}
					getContentAnchorEl={null}
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
					transformOrigin={{ vertical: "top", horizontal: "right" }}
					open={menuLanguageOpen}
					onClose={handleCloseMenuLanguage}
				>
					<MenuItem>
						<LanguageControl />
					</MenuItem>
				</Menu>

				<div className={classes.formContainer}>
					<div className={classes.logoContainer}>
						<img src={logo} alt={nomeEmpresa} className={classes.logo} />
						<Typography className={classes.welcomeText}>
							{i18n.t("login.title")}
						</Typography>
						<Typography className={classes.subtitleText}>
							Entre com suas credenciais para acessar
						</Typography>
					</div>

					<Paper className={classes.paper} elevation={0}>
						<form className={classes.form} noValidate onSubmit={handlSubmit}>
							<TextField
								className={classes.textField}
								variant="outlined"
								fullWidth
								id="email"
								label={i18n.t("login.form.email")}
								name="email"
								value={user.email}
								onChange={handleChangeInput}
								autoComplete="email"
								autoFocus
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Email />
										</InputAdornment>
									),
								}}
							/>
							
							<TextField
								className={classes.textField}
								variant="outlined"
								fullWidth
								name="password"
								label={i18n.t("login.form.password")}
								type={showPassword ? "text" : "password"}
								id="password"
								value={user.password}
								onChange={handleChangeInput}
								autoComplete="current-password"
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Lock />
										</InputAdornment>
									),
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={() => setShowPassword(!showPassword)}
												edge="end"
												size="small"
											>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									),
								}}
							/>

							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submitButton}
								endIcon={<ArrowForward />}
							>
								{i18n.t("login.buttons.submit")}
							</Button>

							<div className={classes.links}>
								<Link component={RouterLink} to="/forgetpsw">
									Esqueceu a senha?
								</Link>
								<Link component={RouterLink} to="/signup">
									{i18n.t("login.buttons.register")}
								</Link>
							</div>
						</form>
					</Paper>
				</div>
			</div>
		</div>
	);
};

export default Login;
